// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification[data-v-71f17d16]{position:absolute;top:0;left:0;z-index:99999;background:red;width:300px;height:300px}", ""]);
// Exports
module.exports = exports;
